import React, { useRef } from 'react';
import {
    Grid,
    CircularProgress,
    Button,
} from '@mui/material';

import MainTemplate from '../templates/MainTemplate';
import SelectField from '../../components/SelectField';
import InputField from '../../components/InputField';
import BasicError from '../../components/BasicError';
import useMdUpScreen from '../../hooks/useMdUpScreen';

function CheckInStep1View({
    viewParameters,
    loading,
    buttonPressed,
    error,
    controls,
    communes,
    onChange,
    onSubmit
}) {
    
    const mdUpScreen = useMdUpScreen();
    const templateRef = useRef(null);

    if (!viewParameters.estilos) {
        return null;
    }
    const layoutProps = { 
        ...viewParameters.layout, 
        extraBackground: !mdUpScreen
    };

    return (
        <MainTemplate templateRef={templateRef} view={{ ...viewParameters, layout: layoutProps }}>
            <Grid container spacing={0}>
                <Grid item xs={12} md={8} sx={viewParameters.estilos.gridItem}>
                    <InputField 
                        showValidation={buttonPressed} 
                        control={controls.name} 
                        handleChange={(e) => onChange("name", e)}
                    />
                </Grid>
                <Grid item xs={12} md={4} sx={viewParameters.estilos.gridItem}>
                    <InputField 
                        showValidation={buttonPressed} 
                        control={controls.phone} 
                        handleChange={(e) => onChange("phone", e)}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={viewParameters.estilos.gridItem}>
                    <InputField 
                        showValidation={buttonPressed} 
                        control={controls.email} 
                        handleChange={(e) => onChange("email", e)}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={viewParameters.estilos.gridItem}>
                    <SelectField 
                        showValidation={buttonPressed} 
                        control={controls.commune} 
                        handleChange={(e) => onChange("commune", e)} 
                        options={communes}
                    />
                </Grid>
                <Grid item xs={12} sx={viewParameters.estilos.gridItem}>
                    <InputField 
                        showValidation={buttonPressed} 
                        control={controls.adress} 
                        handleChange={(e) => onChange("adress", e)}
                    />
                </Grid>

                {error !== '' && (
                    <Grid item xs={12}>
                        <BasicError error={error} />
                    </Grid>
                )}

                <Grid item xs={12} sx={{ p: 1 }}>
                    <Button 
                        disabled={loading} 
                        variant="contained" 
                        sx={viewParameters.estilos.submitButton}
                        onClick={onSubmit}
                    >
                        {loading ? <CircularProgress color="inherit" size={24} /> : 'Enviar datos'}
                    </Button>
                </Grid>
            </Grid>
        </MainTemplate>
    );
}

export default CheckInStep1View;